import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'

import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { User } from '@/modules/User/interfaces/user'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppDialog from '@/components/AppDialog.vue'
import { Message } from '@/modules/Message/interfaces/message'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import { getMessages, markMessagesAsRead, deleteMessageByIds, vergeNotification } from '@/modules/Message/gql/message-gql'
import AppTableDate from '@/components/AppTableDate.vue'
import { translateMasterTypeLink } from '@/utils/translate'
@Component({
  components: {
    AppBreadcrumbs,
    AppDialog,
    AppTableDate
  }
})
export default class MessageList extends Vue {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Message'
    }
  ]

  messageList: Message[] = []
  selected: Message[] = []
  deleteDialog = false
  disableConfirm = false
  messageChecked = {
    id: 0,
    title: '',
    time: '',
    state: ''
  }
  deleteText = ''

  msgToDeleted: number[] = []

  windowSize = {
    w: 0,
    h: 0
  }

  tableColumn = [
    { field: '', title: '', slots: { default: 'select_default', header: 'select_header' }, width: 60, resizable: true },
    { field: 'content', title: 'Messages', slots: { default: 'name_default' }, resizable: true },
    { field: 'createdAt',
      title: 'Date',
      slots: { default: 'created_at' },
      resizable: true
    },
    { field: 'action', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 112, resizable: false }
  ]

  tableOptions = {
    loading: false,
    tablePage: {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      align: 'right',
      size: 'small',
      perfect: true,
      pageSizes: [10, 20, 50, 100, 200, 500]
    },
    sortBy: 'name',
    sortDesc: true
  }

  @State(state => state.user.me) me!: User

  @Watch('me')
  onMeChanged (val: User) {
    if (val) {
      this.getVergeNotification()
    }
  }

  mounted () {
    this.onResize()
    this.getMessages()
    if (this.me) {
      this.getVergeNotification()
    }
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
  }

  batchDeleteMessage () {
    this.deleteDialog = true
    this.msgToDeleted = this.selected.map((msg: Message) => Number(msg.id))
  }

  deleteMessage (item: Message) {
    this.deleteDialog = true
    this.msgToDeleted = [Number(item.id)]
  }

  clearSelected () {
    this.msgToDeleted = []
  }

  async deleteConfirm () {
    this.deleteDialog = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteMessageByIds,
        variables: {
          messageIds: this.msgToDeleted
        }
      })
      const res = result.data.deleteMessageByIds
      if (res) {
        showNotification({
          msg: 'Messages deleted successfully',
          type: SnackType.Success
        })
        this.getMessages()
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async getMessages () {
    this.tableOptions.loading = true
    try {
      const result = await this.$apollo.query({
        query: getMessages,
        variables: {
          paging: {
            offset: 0,
            limit: 10
          },
          filter: null
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      for (const i in result.data.getMessages.messages) {
        result.data.getMessages.messages[i].selected = false
      }
      this.tableOptions.loading = false
      this.messageList = result.data.getMessages.messages
      this.tableOptions.tablePage.total = this.messageList.length
    } catch (e) {}
  }

  async getVergeNotification () {
    const self = this
    const observer = await this.$apollo.subscribe({
      query: vergeNotification,
      variables: {
        userId: Number(this.me.id)
      }
    })

    observer.subscribe({
      next () {
        self.getMessages()
      }
    })
  }

  markAsRead () {
    const ids: number[] = this.selected.map((msg: Message) => Number(msg.id))
    this.markMessagesAsRead(ids)
  }

  async markMessagesAsRead (ids: number[]) {
    ids.map((id: number) => {
      const index = this.$R.findIndex(this.$R.propEq('id', id.toString()))(this.messageList)
      this.messageList[index].read = true
    })
    try {
      await this.$apollo.mutate({
        mutation: markMessagesAsRead,
        variables: {
          ids
        }
      })
    } catch (e) {}
  }

  routeTo (name: string, params: any) {
    this.$router.push({
      name,
      params
    })
  }

  msgClickHandler (message: Message) {
    this.markMessagesAsRead([Number(message.id)])
    this.routeTo(translateMasterTypeLink(message.masterType), {
      id: message.masterId
    })
  }

  selectMessage (item: any) {
    item.selected = true
    this.selected.push(item)
  }

  cancelSelectMessage (item: any) {
    item.selected = false
    const index = this.$R.findIndex(this.$R.propEq('id', item.id))(this.selected)
    if (index >= 0) {
      this.selected.splice(index, 1)
    }
  }

  selectAllMessage () {
    for (const i in this.messageList) {
      this.messageList[i].selected = true
    }
    this.selected = this.messageList
  }

  cancelSelectAllMessage () {
    for (const i in this.messageList) {
      this.messageList[i].selected = false
    }
    this.selected = []
  }
}
